angular.module('am4').directive('passwordMatch', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ngModelCtrl) {
            ngModelCtrl.$validators.passwordMatch = function(modelValue) {
                return modelValue === scope.$eval(attrs.passwordMatch);
            };

            scope.$watch(attrs.passwordMatch, function() {
                ngModelCtrl.$validate();
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/passwordMatch.js